import type { AxiosResponse } from 'axios';
import axios from 'axios';

export interface ForgotPasswordResponseDTO {
  success: boolean;
  error?: {
    email: string[];
  };
}

export interface ResetPasswordResponseDTO {
  success: boolean;
  error?: { token?: string[] };
}

export async function forgotPassword(
  email: string,
  locale?: string,
): Promise<ForgotPasswordResponseDTO> {
  return axios
    .post(`/api/v1/profiles/forgot-password`, {
      action: 'forgot_password',
      email,
      locale,
    })
    .then((res: AxiosResponse) => res.data);
}

export async function resetPassword({
  password,
  confirm,
  token,
}: {
  password: string;
  confirm: string;
  token: string | null;
}): Promise<ResetPasswordResponseDTO> {
  return axios
    .post(`/api/v1/profiles/reset-password`, {
      action: 'reset_password',
      token,
      new_password: password,
      new_password_confirm: confirm,
    })
    .then((res: AxiosResponse) => res.data);
}
